/** Human names of navigation object types — shown only in the ⓘ tooltip, never
 *  as a screen's title. Re-exported by RunNavShell as `RUN_TYPE_LABEL`. */
export const RUN_TYPE_LABEL: Record<string, string> = {
  '-': 'Folder',
  T: 'Transaction',
  D: 'Dashboard',
  V: 'Visual',
  M: 'Visual Schema',
  R: 'Report',
  G: 'General Process',
  W: 'Workflow',
  L: 'Process Overview',
  P: 'Process Data',
  S: 'Smart Page',
  X: 'External Website',
  U: 'Wizard',
  C: 'Custom App',
  K: 'Document Repository',
  H: 'Scheduler',
  J: 'Integration Flow',
  E: 'Document Form',
  SUPPORT: 'Support',
}
